// extracted by mini-css-extract-plugin
var _1 = "lMElh";
export { _1 as "base" }
